export default __webpack_public_path__ + "static/media/blender.5c8d639d.svg";